export const formatCurrency = (value) =>
  Number(value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

// 'YYYY-MM-DD' → 'DD/MM/YYYY'. O sufixo T00:00:00 força parse em horário
// local (sem ele o JS interpreta como UTC e desloca 1 dia em UTC-3).
export const formatDateBR = (iso) =>
  iso ? new Date(iso + 'T00:00:00').toLocaleDateString('pt-BR') : '—';

export const parseMoneyValue = (val) => {
  if (!val) return 0;
  return Number(String(val).replace(/[^\d,-]/g, '').replace(',', '.')) || 0;
};

export const getBalanceColor = (value) => {
  const num = Number(value || 0);
  if (num > 0) return '#60b4f6';
  if (num < 0) return '#ED2D2D';
  return undefined;
};
